<template>
    <div class="check" >
      <div class="pc_dialog">
          <div class="dialog flex_center">
              <div class="dialog_container">
                  <div class="dialog_thumb">
                      <div class="dialog_group">
                          <div class="dialog_title">Payment Information</div>
                          <div class="dialog_content">
                        
                            <form id="payment-form" v-if="channelTag=='STRIPE_PAY'">
                              <div>
                                  <label for="card-number" class="card_label">Bank Card Number:</label>
                                  <div id="card-number" class="card_value"></div>
                              </div>
  
                              <div>
                                  <label for="card-expiry" class="card_label">Expiry Date:</label>
                                  <div id="card-expiry" class="card_value"></div>
                              </div>
                              <div>
                                  <label for="card-cvc" class="card_label">CVC:</label>
                                  <div id="card-cvc" class="card_value"></div>
                              </div>
                           
                            </form>
                         
                            <el-form label-position="top" label-width="80px" :model="payForm" ref="paymentForm" :rules="payRules" v-else>
                              <div class="input_thumb grid">
                                <div class="input_group grid_md_6 grid_xs_12">
                                  <el-form-item label="Bank Card Number" prop="cardNo">
                                    <el-input v-model="payForm.cardNo" placeholder="Enter card number" ></el-input>
                                  </el-form-item> 
                                </div>
                                <div class="input_group grid_md_6 grid_xs_12">
                                  <el-form-item label="CVV" prop="cvv">
                                    <el-input v-model="payForm.cvv" placeholder="CVV"></el-input>
                                  </el-form-item> 
                                </div>
                                <div class="input_group grid_md_6 grid_xs_12">
                                  <el-form-item label="Expiry date" prop="year">
                                    <el-select v-model="payForm.year" placeholder="Year">
                                      <el-option
                                        v-for="item in yearOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </div>
                                <div class="input_group grid_md_6 grid_xs_12">
                                  <el-form-item label="Expiry date" prop="month">
                                    <el-select v-model="payForm.month" placeholder="Month">
                                      <el-option
                                        v-for="item in monthOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </div> 
                              </div>
                           </el-form>
                          </div>
                      </div>
                      <div class="pay_bottom">
                        <div class="pay_tips">Note: Please ensure that the filled address exactly matches with the address associated with your bank account/card, otherwise the payment might be failed</div>
                        <div class="dialog_btn" @click="toPayment()"><div>Pay Now</div></div>
                      </div>
                      <div class="btn_close iconfont icon-close" @click="closeDialog()"></div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <remote-js src="https://pv.sohu.com/cityjson?ie=utf-8"></remote-js> -->
    </div>
  </template>
  
  <script>
   
  

  // import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'
  
  
   import axios from 'axios';
  export default {
    components:{
      // 'remote-js': {
      //     render (createElement) {
      //         return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
      //     },
      //     props: {
      //         src: { type: String, required: true },
      //     },
      //   },
      
      
    },
    props:{
      showDialog:{
        type:Boolean,
        default:false,
      },
      orderId:'',
      channelTag:'', // STRIPE_PAY 切换支付接口
      shopName:'',
      stripeKey:'',
     
    },
    data(){
      return{
        
        visbleDialog:this.showDialog,
        payForm:{
         
          email:'',
          year:'',
          month:'',
          cvv:'',
          ip:'',
          cardNo:'',
          orderId:'',
          token:'',
        },
        payRules:{
          year: [  { required: true, message:'Enter the full year', trigger: 'change' } ],
          month: [  { required: true, message: 'Enter the full month', trigger: 'change' } ],
          cvv: [  { required: true, message: 'Enter the full cvv', trigger: 'blur' } ],
          cardNo: [  { required: true, message: 'Enter the full card number', trigger: 'blur' }, { min: 13, max: 19, message: 'Length of 13 to 19', trigger: 'change' } ],
        },
        yearOptions:[
              {value:'2024',label:'2024'},{value:'2025',label:'2025'},{value:'2026',label:'2026'},{value:'2027',label:'2027'},{value:'2028',label:'2028'},
              {value:'2029',label:'2029'},{value:'2030',label:'2030'},{value:'2031',label:'2031'},{value:'2032',label:'2032'},{value:'2033',label:'2033'},
          ],
        monthOptions:[
            {value:'01',label:'01'},{value:'02',label:'02'},{value:'03',label:'03'},{value:'04',label:'04'},{value:'05',label:'05'},
            {value:'06',label:'06'},{value:'07',label:'07'},{value:'08',label:'08'},{value:'09',label:'09'},{value:'10',label:'10'},
            {value:'11',label:'11'},{value:'12',label:'12'}
        ],
        countryOptions: [],
        stateOptions:[],
      }
    },
    created(){
      this.getIp()
      if(this.channelTag=='STRIPE_PAY'){
        this.getScript()
      }
 
    
    },
    methods:{
      async getIp () {
        try {
          let res = await axios.get('https://ipv4.icanhazip.com/')
          this.payForm.ip = res.data.replace(/[\n\t\s]+/g, '');
          console.log( this.payForm.ip,'公网ip')
          return this.payForm.ip
        } catch (err) {
            setTimeout(() => {
            this.getIp()
            }, 2000)
        }
      },
      toPayment(){
        if(this.channelTag =='STRIPE_PAY'){
          let _this = this
            this.stripe2.createToken(this.cardNumberElement).then(function(result){   
            if (result.error) {
                // 处理错误
                console.log('result,result',result)
                _this.$message.error(result.error.message)  
              } else {
                // Token 创建成功，将其传递给后端代码
                var token = result.token.id;
                _this.payForm.token = token
                _this.payment()
                console.log(token,'token')            
            }
          })
          return 
        } 
        this.$refs['paymentForm'].validate((valid) => {
          if (valid) {
              console.log('success',this.payForm,this.orderId)
              this.payment()
              // this.$emit('upPayForm',this.payForm)
          } else {            
          }
        })
      },
      payment(){
        let _this = this
        let payForm = this.payForm
        let orderNo = this.orderId
        let ip = payForm.ip
        let token = payForm.token
        this.$store.commit('setLoad',true)
        this.$axios({
                  url:'/game_api/order/pay',
                  method:'post',
                  data:{  
                    orderNo:orderNo,
                    ip:ip,
                    token:token
                  },
                  headers: {
                  // 'Content-type':'application/json'
                  }
              })
              .then(res=>{
                this.$store.commit('setLoad',false)
                let data = res.data
                if(data.code == 200){
                  if(data.data.respCode ==10000){
                    _this.$message.success(data.data.respMessage)
                   
                  }
                  else  if(data.data.respCode !=10000){
                    _this.$message.error(data.data.respMessage)
                  
                  }
                }
                else{
                  _this.$Message.error(data.msg)
                }
                console.log('data',res.data)
              })
              .catch(err=>{
                this.$store.commit('setLoad',false)
              })
      
      },
      handleToken(token) {
        // 处理生成的 token
        console.log(token,'tokentokentoken');
      },
      closeDialog(){
        console.log('closeDialog',false)
        this.$emit('closeDialog',false)
      },
      async getScript(){
        
      
        if(Stripe){
          // 创建Elements实例
          // let stripe2 = Stripe('pk_live_51QRl2uKGPnL9JpEdBFbE9hhc3tO9NGwDD0qmWMq1HI7Pb4opME7hH1WbY6EVvqScoNgOIbKWh5xGqBBB4vRLZa5500NOtmxXSy');
          const stripe2 = await Stripe(this.stripeKey,{locale:'en'});
          const elements = stripe2.elements();
          let cardNumberElement = elements.create('cardNumber');
          let cardExpiryElement = elements.create('cardExpiry');
          let cardCvcElement = elements.create('cardCvc');
          cardNumberElement.mount('#card-number');
          cardExpiryElement.mount('#card-expiry');
          cardCvcElement.mount('#card-cvc');
          this.cardNumberElement = cardNumberElement
          this.cardExpiryElement = cardExpiryElement
          this.cardCvcElement = cardCvcElement
  
          this.stripe2 = stripe2
          let form = document.getElementById('payment-form');
          this.cardNumberElement.addEventListener('change', (event) => {
            
          if (event.error) {
            console.log('支付元素出现错误：', );
          } else {
            console.log('支付元素状态正常',event);
          }
        });
          form.addEventListener('submit', function(event) {
      
          event.preventDefault();
          stripe2.createToken(cardNumberElement).then(function(result) {
              if (result.error) {
                  // 处理错误
                  console.log('result,result',result.error.message)
                  alert(result.error.message);
              } else {
                  // Token 创建成功，将其传递给后端代码
                  var token = result.token.id;
                  console.log(token)
                  
              }
           });
         });
         return
        }else{
          setTimeout(()=>{
            this.getScript()
          },1000)
        }
      }
    },
    mounted(){
      
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .dialog{ 
  position: fixed;
  // margin-top:100px;
  left:0;
  top:0;
  right:0;
  bottom:0;
  background:#0000008f;
  z-index: 999;
  .dialog_container{
    padding:16px 72px;
    width: 704px;
    max-width: 100%;
    margin:0 auto;
    position: relative;
    // top:5%;
    border-radius: 6px;
    .dialog_thumb{
      background:#fff;
      border-radius: 6px;
      overflow: hidden;
    }
    .card_label{
      font-size: 14px;
      color:#606266;
    }
    .card_value{
      font-size: 12px;
      padding: 15px;
      // height: 46px;
      border-radius: 4px;
      border:1px solid #e8e9ed;
      margin:6px 0 12px;
      background: #eff2f5;
      border: 1px solid #eff2f5;
      color:#eff2f5;
      line-height: 46px;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
      &:hover{
       border:1px solid #ffd633 !important
      }
    }
    .dialog_group{
      border-radius: 6px;
      text-align: left;
      width: 100%;
      // padding: 0 24px 24px;
      .dialog_title{
        font-size: 20px;
        line-height: 40px;
        background: #f7f7f7;
        color: #282828;
        margin-bottom: 16px;
        text-align: center;
        font-weight: 600;
      }
    
      .dialog_content{
          position: relative;
         padding:0 24px;
        .input_thumb{
          grid-column-gap:8px;
          .input_group{
            margin-bottom:10px;
          }
        } 
        /deep/.el-form-item__label{
          line-height: 20px;
          padding-bottom:8px;
        }
         
  
      }
       .dialog_text{
          font-size: 12px;
          line-height: 20px;
          margin-top: 12px;
          color:#77808c;
          text-align: center;
          .link_tab{
              cursor: pointer;
              // text-decoration: underline;
              &:hover{
                  text-decoration: underline;
              }
              // text-decoration-color: transparent;
          }
          .link_line{
              margin:0px 8px;
              color:#e8e9ed;
          }
          
          
        }
        
    }
    .pay_tips{
      font-size: 14px;
      line-height: 20px;
      padding: 12px 16px;
      flex: 0 0 auto;
      color: #ff9500;
      background-color: rgba(255, 149, 0, .06);
      position: relative
    }
    .btn_close{
      background:#fff;
      color:#0f0f0f;
      font-size: 24px;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      position: absolute;
      top:16px;
      right:10px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      &:hover{
        opacity: 0.7;
      }
    }
  }
  
  }
  /deep/.el-input__inner{
      background:#eff2f5;
      height: 46px;
      border:1px solid #eff2f5;
      box-sizing: border-box;
      &:focus{
        border:1px solid #ffd633!important;
      }
      &:hover{
        border:1px solid #ffd633!important;
      }
  }
  /deep/.el-select{
    width: 100%;
  }
  .dialog_btn{
    padding:16px;
      >div{
        width: 100%;
      height: 48px;
      font-size: 16px;
      line-height: 48px;
      font-weight: 700;
      cursor: pointer;
      background:linear-gradient(89.92deg, #e477ff .07%, #9377ff);
      border-radius: 6px;
      text-align: center;
     
      }
      &:hover{
          opacity: 0.7;
      }
  }
  @media screen and (max-width:768px) {
    .dialog_container{
      width:100%;
      top:0!important;
      left:0;
      right:0;
      bottom:0;
      padding:0!important;
      height: 100%;
     .dialog_thumb{
      height: 100%;
      overflow-y: scroll !important;
      border-radius: 0 !important;
      .dialog_title{
        position: sticky;
        top:0;
        height: 80px;
        z-index:1000;
        box-shadow:  0px 0px 4px -1px rgba(0, 0, 0, .1), 0px 0px 5px 0px rgba(0, 0, 0, .08), 0px 0px 10px 0px rgba(0, 0, 0, .05);
      }
      .pay_bottom{
        position: sticky;
        bottom:0;
        z-index: 1000;
        background: #fff;
      }
      // .pay_tips{
      //   position: sticky;
      //   bottom:80px;
      //   z-index: 1000;
      // }
      // .dialog_btn{
        
      // }
     }
     
      .btn_close{
        left:16px;
        z-index: 1001;
      }
     
    }
  }
  
  </style>